import watermarkDecoderSlice from "../slices/watermarkDecoderSlice";

export const {
  RequestWatermarkUpload,
  SuccessWatermarkUpload,
  FailureWatermarkUpload,
  RequestManualWatermarkDecode,
  SuccessManualWatermarkDecode,
  FailureManualWatermarkDecode,
  ResetWatermarkDecoder,
} = watermarkDecoderSlice.actions;
